import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  const resource = properties.resource;
  const operation = properties.operation;

  // Message Send validation
  if (resource === 'message' && operation === 'send') {
    if (!properties.toRecipients) {
      errors.push({ key: 'toRecipients', message: 'To recipients are required' });
    }
    if (!properties.bodyContent) {
      errors.push({ key: 'bodyContent', message: 'Message body is required' });
    }
  }

  // Message Reply validation
  if (resource === 'message' && operation === 'reply') {
    if (!properties.messageId) {
      errors.push({ key: 'messageId', message: 'Message ID is required' });
    }
    if (!properties.replyComment) {
      errors.push({ key: 'replyComment', message: 'Reply message is required' });
    }
  }

  // Event Create validation
  if (resource === 'event' && operation === 'create') {
    if (!properties.eventSubject) {
      errors.push({ key: 'eventSubject', message: 'Event subject is required' });
    }
    if (!properties.eventStartTime) {
      errors.push({ key: 'eventStartTime', message: 'Start time is required' });
    }
    if (!properties.eventEndTime) {
      errors.push({ key: 'eventEndTime', message: 'End time is required' });
    }
  }

  // Folder Create validation
  if (resource === 'folder' && operation === 'create') {
    if (!properties.folderName) {
      errors.push({ key: 'folderName', message: 'Folder name is required' });
    }
  }

  // Attachment Add validation
  if (resource === 'attachment' && operation === 'add') {
    if (!properties.attachmentMessageId) {
      errors.push({ key: 'attachmentMessageId', message: 'Message ID is required' });
    }
    if (!properties.attachmentName) {
      errors.push({ key: 'attachmentName', message: 'File name is required' });
    }
    if (!properties.attachmentContentBase64) {
      errors.push({ key: 'attachmentContentBase64', message: 'Attachment content is required' });
    }
  }

  return {
    valid: errors.length === 0,
    errors
  };
}
